var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4014 43.1003C18.4014 45.2454 20.0955 47.0004 22.1661 47.0004C24.2366 47.0004 25.9307 45.2454 25.9307 43.1003H18.4014V43.1003ZM24.9894 12.251V10.925C24.9894 9.30652 23.7283 8 22.1659 8C20.6036 8 19.3424 9.30652 19.3424 10.925V12.251C13.9401 13.577 9.9307 18.5886 9.9307 24.5752V35.3003L6.16602 39.2003V41.1503H38.1658V39.2003L34.4011 35.3003V24.5752C34.4011 18.5886 30.3918 13.577 24.9894 12.251V12.251Z",
    fill: "#9DA1B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.913 0.929199C46.1177 0.929199 49.5262 4.33776 49.5262 8.54242C49.5262 12.7471 46.1177 16.1556 41.913 16.1556C37.7084 16.1556 34.2998 12.7471 34.2998 8.54242C34.2998 4.33776 37.7084 0.929199 41.913 0.929199V0.929199Z",
    fill: "#F75151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.013d37efcbfa42c2052e0b3567d4de74.svg";
export { ForwardRef as ReactComponent };